import React from 'react'
import PropTypes from 'prop-types'

/**
 * Component for adding a button
 */
function Button ({ text, type, color, size, width, onClick, disabled }) {
  const buttonClass = prop => prop ? 'btn-' + prop : null

  const classNames = [
    'btn',
    buttonClass(color),
    buttonClass(size),
    buttonClass(width)
  ]

  return (
    <button
      type={type} onClick={onClick} className={classNames.join(' ')}
      disabled={disabled}
    >
      {text}
    </button>
  )
}

Button.defaultProps = {
  onClick: null,
  color: 'primary',
  type: 'button'
}

Button.propTypes = {
  /**
     * Button text
     */
  text: PropTypes.string.isRequired,
  /**
     * Button type attribute
     */
  type: PropTypes.string,
  /**
     * Color of the button<br>
     * Colors: 'primary', 'white', 'bordered'
     */
  color: PropTypes.string,
  /**
     * Size of the button<br>
     * Sizes: 'default', 'small'
     */
  size: PropTypes.string,
  /**
     * Width of the button<br>
     * Sizes: 'default', 'wide', 'full'
     */
  width: PropTypes.string,
  /**
     * Disabled attribute
     */
  disabled: PropTypes.bool,
  /**
     * Click event handler
     */
  onClick: PropTypes.func
}

export default Button
